import { observer } from "mobx-react-lite";
import React from "react";
import styled from "styled-components";
import { UiConstants } from "../../../../data/UiConstants";
import { Submenu } from "../../../menu/PopupSubMenu";
import { ItemConfigurator } from "../editors/ItemConfigurator";
const EditorPopupContainer = styled(Submenu).withConfig({
  displayName: "ItemEditorWindow__EditorPopupContainer",
  componentId: "sc-ikk2i3-0"
})(["z-index:", ";transform:", ";position:absolute;"], UiConstants.Z_INDEX_POPUP_SUBMENU + 5, props => `translateX(${props.moveX}px)`);
export const ItemEditorWindow = observer(props => {
  const itemEditorWindowWidth = 420;
  return /*#__PURE__*/React.createElement(EditorPopupContainer, {
    moveX: (props.selectorWidth + itemEditorWindowWidth) * -1
  }, /*#__PURE__*/React.createElement(ItemConfigurator, {
    closeEditor: props.closeEditor
  }));
});